import type { ProtocolType } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getProtocolTypeIcon(template: ProtocolType): IconName {
	switch (template) {
		case "general":
			return "File";
		case "meeting":
			return "Calendar";
		case "negotiation":
			return "Handshake";
		case "call-request":
			return "Headset";
		default:
			return "File";
	}
}
